<template>
  <div ref="chartContainer">
    <apexchart ref="chart" type="line" :height="height" :series="series" :options="chartOptions" :width="width">
    </apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue3-apexcharts';

export default {
  name: "LineChart",
  components: { apexchart: VueApexCharts },
  props: {
    series: { type: Array, required: true },
    height: { type: [String, Number], default: 350 },
    width: { type: [String, Number], default: null },
    options: { type: Object, default: () => ({}) },
    isCurrency: { type: Boolean, default: true },  
  },
  data() {
    return { chartOptions: this.mergeChartOptions() };
  },
  methods: {
    mergeChartOptions() {
      const defaultOptions = {
        chart: {
          toolbar: {
            show: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 4,
          curve: 'smooth',
        },
        xaxis: {
          type: 'category',
          categories: [
            "Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"
          ],
        }
      };

      if (this.isCurrency) {
        defaultOptions.yaxis = {
          labels: {
            formatter: function (value) {
              const formatter = new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              });
              return formatter.format(value);
            },
          },
        };

        defaultOptions.tooltip = {
          y: {
            formatter: function (val) {
              const formatter = new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              });
              return formatter.format(val);
            },
          },
        };
      }

      return Object.assign({}, defaultOptions, this.options);
    },
  },
};
</script>
